/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `*,
*:focus {
  outline: none;
}

/* default */
:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
}
:host .label {
  font-size: inherit;
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
  line-height: calc(22rem/14);
}
:host .slider {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
          flex-direction: row;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
          justify-content: flex-start;
  align-content: flex-start;
  -webkit-box-align: center;
          align-items: center;
  margin-top: calc(2rem/14);
  margin-right: calc(17rem/14);
  margin-bottom: calc(8rem/14);
  margin-left: 0;
}
:host .slotwrapper {
  -webkit-box-ordinal-group: 1;
          order: 0;
  -webkit-box-flex: 0;
          flex: 0 0 auto;
  align-self: auto;
  padding-right: calc(5rem/14);
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
}
:host .icon {
  margin-top: calc(-2rem/14);
  fill: #B4BEC5;
  fill: var(--davinci-color-midgray-2, #B4BEC5);
}
:host .icon davinci-icon,
:host .icon davinci-icon-ref {
  font-size: 1rem;
}
:host .bar_container {
  width: 100%;
  margin: calc(12rem/14);
  cursor: pointer;
  touch-action: none;
}
:host .bar_outer {
  margin-top: calc(15rem/14);
  -webkit-box-flex: 1;
          flex: 1 1 auto;
  height: calc(2rem/14);
  width: 100%;
  border-radius: calc(100rem/14);
  background: #D2D9DD;
  background: var(--davinci-color-midgray-3, #D2D9DD);
}
:host .bar_inner {
  height: calc(2rem/14);
  border-radius: calc(100rem/14);
  background: #007CC1;
  background: var(--davinci-color-primary, #007CC1);
}
:host .knob {
  position: relative;
  float: left;
  width: calc(16rem/14);
  height: calc(16rem/14);
  border-radius: 100%;
  -webkit-transform: translate(-50%, -58%);
          transform: translate(-50%, -58%);
  background: #007CC1;
  background: var(--davinci-color-primary, #007CC1);
  z-index: 2;
}
:host .knob:after {
  content: "";
  position: absolute;
  top: calc(-16rem/14);
  bottom: calc(-16rem/14);
  left: calc(-16rem/14);
  right: calc(-16rem/14);
}
:host div[data-id="1"] {
  -webkit-transform: translate(-150%, -58%);
          transform: translate(-150%, -58%);
}
:host .knob:hover {
  box-shadow: 0 0 0 calc(9rem/14) var(--davinci-color-primary-25,rgba(0, 124, 193, 0.25));
}
:host .knob.pressed + .knob:hover {
  box-shadow: none !important;
}
:host .knob.focused,
:host .knob[data-id="0"].focused {
  box-shadow: 0 0 0 calc(9rem/14) var(--davinci-color-primary-45,rgba(0, 124, 193, 0.45));
}
:host .knob[data-id="1"].focused {
  box-shadow: 0 0 0 calc(9rem/14) var(--davinci-color-primary-45,rgba(0, 124, 193, 0.45));
}
:host .knob.pressed,
:host .knob[data-id="0"].pressed {
  -webkit-transform: translate(-50%, -58%) scale(1.25);
          transform: translate(-50%, -58%) scale(1.25);
  box-shadow: 0 0 0 calc(5.6rem/14) var(--davinci-color-primary-25,rgba(0, 124, 193, 0.25)) !important;
}
:host .knob[data-id="1"].pressed {
  -webkit-transform: translate(-150%, -58%) scale(1.25);
          transform: translate(-150%, -58%) scale(1.25);
  box-shadow: 0 0 0 calc(5.6rem/14) var(--davinci-color-primary-25,rgba(0, 124, 193, 0.25)) !important;
}
:host .knob:active {
  cursor: pointer;
  outline: none;
}
:host .legend {
  position: relative;
  width: 100%;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}
:host .verticalLines {
  position: absolute;
  width: 100%;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
          flex-direction: row;
  flex-wrap: nowrap;
  -webkit-box-pack: justify;
          justify-content: space-between;
  align-content: center;
  -webkit-box-align: center;
          align-items: center;
  margin-top: calc(4rem/14);
  margin-bottom: calc(2rem/14);
}
:host .verticalLine {
  -webkit-box-ordinal-group: 1;
          order: 0;
  -webkit-box-flex: 0;
          flex: 0 1 auto;
  align-self: auto;
  float: left;
  width: calc(1rem/14);
  height: calc(12rem/14);
  background: #D2D9DD;
  background: var(--davinci-color-midgray-3, #D2D9DD);
  border: none;
  border-radius: calc(100rem/14);
}
:host .values {
  position: relative;
  width: 100%;
}
:host .value {
  position: absolute;
  left: 50%;
  -webkit-transform: translate(-50%, 0);
          transform: translate(-50%, 0);
  margin-top: calc(14rem/14);
  color: #505F6B;
  color: var(--davinci-color-dark-gray-3, #505F6B);
}

:host([legend=true]) {
  margin-bottom: calc(15rem/14);
}

:host([disabled]) {
  pointer-events: none;
  color: #D2D9DD;
  color: var(--davinci-color-midgray-3, #D2D9DD);
}
:host([disabled]) .icon {
  fill: #D2D9DD;
  fill: var(--davinci-color-midgray-3, #D2D9DD);
}
:host([disabled]) .bar_container,
:host([disabled]) .knob {
  cursor: default;
}
:host([disabled]) .bar_inner,
:host([disabled]) .knob {
  background: var(--davinci-color-midgray-3,#D2D9DD) !important;
  box-shadow: none !important;
}
:host([disabled]) .verticalLine {
  background: #D2D9DD;
  background: var(--davinci-color-midgray-3, #D2D9DD);
}`;
export { style };
//# sourceMappingURL=Slider.style.js.map